<script setup lang="ts">
import { onMounted } from 'vue'

import RegistrationStatsDashboard from '@/components/statistics/RegistrationStatsDashboard.vue'

definePage({
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
  },
})

const { t } = useI18n()
const { setPageTitle } = useBreadcrumbs()

onMounted(() => {
  setPageTitle(t('router.pages.admin-activity'))
})
</script>

<template>
  <RegistrationStatsDashboard :title="t('router.pages.admin-activity')" />
</template>
